import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {LeadService} from "../../../services/lead-service/lead.service";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {BehaviorSubject} from "rxjs";
import {isNullOrUndefined} from "util";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {FormControl, FormGroup} from "@angular/forms";
import {FieldId} from "../../../model/activation/FieldId";
import {ActivationControllerService} from "../../../api/services/activation-controller.service";
import {SearchControllerService} from "../../../api/services/search-controller.service";
import {PlanHolderSaveRequest} from "../../../api/models/plan-holder-save-request";
import {PlanHolderDetailsResponse} from "../../../api/models/plan-holder-details-response";
import {PrimaryDriverSave} from "../../../api/models/primary-driver-save";
import {PlanHolderSave} from "../../../api/models/plan-holder-save";
import {SearchResponseItem} from "../../../api/models/search-response-item";
import {PlanHolderDetailsViewComponentItem} from "../../../api/models/plan-holder-details-view-component-item";
import {ViewInputOption} from "../../../api/models/view-input-option";
import {ValidationService} from "../../../services/validation-service/validation.service";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-planholder-details',
  templateUrl: './activation-planholder-details.component.html'
})
export class ActivationPlanholderDetailsComponent implements OnInit {
  viewLoading = false;
  view: PlanHolderDetailsResponse;
  showSpinner = false;

  planholderDetailsSection: PlanHolderDetailsViewComponentItem;
  planholderContactDetailsSection: PlanHolderDetailsViewComponentItem;
  planholderLicenseDetailsSection: PlanHolderDetailsViewComponentItem;
  planholderDetailsForm: FormGroup = new FormGroup({});

  primaryDriverSection: PlanHolderDetailsViewComponentItem;
  primaryDriverContactDetailsSection: PlanHolderDetailsViewComponentItem;
  primaryDriverLicenseDetailsSection: PlanHolderDetailsViewComponentItem;

  occupationSearchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  occupationList: BehaviorSubject<SearchResponseItem[]> = new BehaviorSubject<SearchResponseItem[]>([]);
  occupationSearched = false;
  loadingOccupations = false;
  planholderOccupationDescription;
  driverOccupationDescription;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public activationControllerService: ActivationControllerService,
              public searchControllerService: SearchControllerService,
              private _validationService: ValidationService,
              private _leadService: LeadService,
              private _gtmService: GtmService) { }

  ngOnInit() {
    this._loadView();
    this.quotationService.scrollToTop();
    this.occupationSearchTerm.pipe(debounceTime(500),
      distinctUntilChanged()).subscribe(term => {
      this.searchOccupations(term);
    });
  }

  private _loadView() {
    this.viewLoading = true;
    this.activationControllerService.activationV1PlanHolderDetailsGetResponse().subscribe(response => {
      this.viewLoading = false;
      this.view = response.body;
      this.planholderDetailsSection = this.view.views.find(view => view.id === 'PLAN_HOLDER');
      this.planholderDetailsSection.collapsed = false;
      this.planholderContactDetailsSection = this.view.views.find(view => view.id === 'PLAN_HOLDER_CONTACT');
      this.planholderLicenseDetailsSection = this.view.views.find(view => view.id === 'LICENSE_DETAILS');
      this.primaryDriverSection = this.view.views.find(view => view.id === 'PRIMARY_DRIVER');
      this.primaryDriverContactDetailsSection = this.view.views.find(view => view.id === 'PRIMARY_DRIVER_CONTACT');
      this.primaryDriverLicenseDetailsSection = this.view.views.find(view => view.id === 'PRIMARY_DRIVER_LICENSE_DETAILS');
      this._createForm();
    }, error => {
      this.quotationService.error = true;
    });
  }

  private _createForm() {
    this.planholderDetailsSection.views.forEach(field => {
      this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
    })
    const planholderOccupation: ViewInputOption = this.planholderDetailsSection.views.find(field => field.id === 'PLAN_HOLDER_OCCUPATION').options[0];
    this.selectOccupation(true, {id: planholderOccupation.id, label: planholderOccupation.label});

    this.planholderContactDetailsSection.views.forEach(field => {
      this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
    })

    if (this.planholderLicenseDetailsSection != null) {
      this.planholderLicenseDetailsSection.views.forEach(field => {
        this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
      })
    }

    if (this.primaryDriverSection) {
      this.primaryDriverSection.views.forEach(field => {
        this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)))
      })
      this.primaryDriverSection.collapsed = false;
      const driverOccupation: ViewInputOption = this.primaryDriverSection.views.find(field => field.id === 'PRIMARY_DRIVER_OCCUPATION').options[0];
      this.selectOccupation(false, {id: driverOccupation.id, label: driverOccupation.label});

      this.primaryDriverContactDetailsSection.views.forEach(field => {
        this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
      })

      if (this.primaryDriverLicenseDetailsSection) {
        this.primaryDriverLicenseDetailsSection.views.forEach(field => {
          this.planholderDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
        })
      }
    }

    this._reloadJCF();
  }

  private _reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  showFieldError(field) {
    return this.planholderDetailsForm.controls[field].invalid && this.planholderDetailsForm.controls[field].dirty;
  }

  occupationInputChange(value: any) {
    this.occupationSearchTerm.next(value);
  }

  searchOccupations(searchTerm: string): void {
    this.occupationSearched = false;

    if (searchTerm.length >= 3) {
      this.loadingOccupations = true;
      // clean any special chars from the input
      searchTerm = searchTerm.replace(/[^a-zA-Z\-\'\s\,]/g, '');
      this.searchControllerService.searchV1OccupationGetResponse({search: searchTerm, maxResults: 10}).subscribe(response => {
        if (response.body == null) {
          this.occupationSearched = true;
        } else {
          this.occupationSearched = false;
        }
        this.loadingOccupations = false;
        this.occupationList.next(response.body);
      }, error => {
        this.quotationService.error = true;
        this.loadingOccupations = false;
      });
    }
  }

  selectOccupation(planholder: boolean, occupation: SearchResponseItem) {
    if (!isNullOrUndefined(occupation)) {
      this.loadingOccupations = false;
      this.occupationSearched = false;
      if (planholder) {
        this.planholderOccupationDescription = occupation.label;
        this.planholderDetailsForm.controls.PLAN_HOLDER_OCCUPATION.setValue(occupation.id);
      } else {
        this.driverOccupationDescription = occupation.label;
        this.planholderDetailsForm.controls.PRIMARY_DRIVER_OCCUPATION.setValue(occupation.id);
      }
    }
    this.occupationList.next([]);
  }

  trimTextValues(formControlName) {
    this.planholderDetailsForm.controls[formControlName].setValue(this.planholderDetailsForm.controls[formControlName].value.trim());
  }

  saveAndContinue() {
    this.showSpinner = true;
    this.activationControllerService.activationV1PlanHolderDetailsPutResponse(this._getSaveDetailsRequest()).subscribe(response => {
      this.showSpinner = false;
      if (response.status === 200 && response.body.status === 'VALID') {
        this._leadService.insureRecommendedQuote = 'Planholder details';
        this._leadService.updateLead().subscribe();
        this._gtmService.postGtmEvent('form_step_complete', 'submit_planholder_details', 5);
        this.router.navigateByUrl('activation-vehicle-details');
      } else {
        this.quotationService.error = true;
      }
    }, error => {
      this.quotationService.error = true;
    });
  }

  private _getSaveDetailsRequest(): PlanHolderSaveRequest {
    const answersMap = new Map();
    Object.keys(this.planholderDetailsForm.controls).forEach(field => answersMap.set(field, this.planholderDetailsForm.get(field).value));

    const planholderDetails: PlanHolderSave = {
      cellphone: answersMap.get(FieldId.PLAN_HOLDER_CONTACT_CELLPHONE_NUMBER),
      email: answersMap.get(FieldId.PLAN_HOLDER_CONTACT_EMAIL),
      initials: answersMap.get(FieldId.PLAN_HOLDER_INITIALS),
      maritalStatusCode: answersMap.get(FieldId.PLAN_HOLDER_MARITAL_STATUS),
      occupationCode: answersMap.get(FieldId.PLAN_HOLDER_OCCUPATION),
      previouslyCancelled: answersMap.get(FieldId.PLAN_HOLDER_INSURANCE_CANCELLED),
      titleCode: answersMap.get(FieldId.PLAN_HOLDER_TITLE)
    }

    let driverDetails: PrimaryDriverSave = {};
    if (!this.primaryDriverSection) {
      driverDetails = {
        ...planholderDetails,
        yearsAtPreviousInsurerCode: answersMap.get(FieldId.PLAN_HOLDER_YEARS_PREVIOUS_INSURER),
        numberOfClaims: answersMap.get(FieldId.PLAN_HOLDER_NUMBER_OF_CLAIMS),
        license: {
          number: answersMap.get(FieldId.LICENSE_DETAILS_LICENSE_NUMBER),
          typeCode: answersMap.get(FieldId.LICENSE_DETAILS_LICENSE_TYPE),
          issueDate: answersMap.get(FieldId.LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE),
        }
      }
    } else {
      driverDetails = {
        cellphone: answersMap.get(FieldId.PRIMARY_DRIVER_CONTACT_CELLPHONE_NUMBER),
        email: answersMap.get(FieldId.PRIMARY_DRIVER_CONTACT_EMAIL),
        initials: answersMap.get(FieldId.PRIMARY_DRIVER_INITIALS),
        maritalStatusCode: answersMap.get(FieldId.PRIMARY_DRIVER_MARITAL_STATUS),
        occupationCode: answersMap.get(FieldId.PRIMARY_DRIVER_OCCUPATION),
        numberOfClaims: answersMap.get(FieldId.PRIMARY_DRIVER_NUMBER_OF_CLAIMS),
        yearsAtPreviousInsurerCode: answersMap.get(FieldId.PRIMARY_DRIVER_YEARS_PREVIOUS_INSURER),
        titleCode: answersMap.get(FieldId.PRIMARY_DRIVER_TITLE),
        license: {
          number: answersMap.get(FieldId.PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_NUMBER),
          typeCode: answersMap.get(FieldId.PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_TYPE),
          issueDate: answersMap.get(FieldId.PRIMARY_DRIVER_LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE),
        }
      }
    }

    return {planholder: planholderDetails, driver: driverDetails};
  }

  goBack() {
    this._gtmService.postGtmEvent('back_button_clicked', 'planholder_details_back', 5);
    this.router.navigateByUrl('quote-step-three');
  }

}

